// extracted by mini-css-extract-plugin
export default {"item":"Row_item__fPpiH","label":"Row_label__HcbJS","value":"Row_value__BtaT1"};